module.exports = __webpack_public_path__ + "img/company24.869679d8.png";